import moment from 'moment';

export default function HistoryTask({ show, history = [] }: { show: boolean; history: any }) {
  return (
    <div className={`${show ? 'block' : 'hidden'} relative overflow-x-auto`}>
      <table className="w-full text-sm text-left  text-gray-500 ">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3">
              No
            </th>
            <th scope="col" className="px-6 py-3">
              Timestamp
            </th>
            <th scope="col" className="px-6 py-3">
              Type
            </th>
            <th scope="col" className="px-6 py-3">
              User
            </th>
            <th scope="col" className="px-6 py-3">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {history.map((item: any, index: number) => (
            <tr className="bg-white border-b " key={index}>
              <td scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                {index + 1}
              </td>
              <td className="px-6 py-4">{moment(item.time_stamp).local().format('DD MMMM YYYY HH:mm')}</td>
              <td className="px-6 py-4">{item.entity_type}</td>
              <td className="px-6 py-4">{item.user_fullname}</td>
              <td className="px-6 py-4">{item.operation_type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
